// extracted by mini-css-extract-plugin
export default {"FormDiv":"Employer_FormDiv__RhBUE","Icon":"Employer_Icon__4LSVG"};